module.exports = __webpack_public_path__ + "static/media/phone.b260eaf7.svg";